import { Theme } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  defaultSelect: {
    color: theme.palette.grey[700],
  },
  formControl: {
    margin: `0 ${theme.spacing(2)}`,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  popoverContents: {
    maxWidth: '900px',
  },
}));

export default useStyles;
